/**
 * Undo a merge's strings (decision 7500; T3098): the Duplicates report's Merged
 * view, the Undo Merge window and the import's earlier-run line, spread into the
 * one lookup in `strings.ts`. 🔨 This file imports nothing, because the lookup
 * imports it.
 */
export const UNDO_MERGE_STRINGS = {
  'duplicates.view.merged': 'Merged',
  'duplicates.merged.col.mergedAway': 'Merged Away',
  'duplicates.merged.col.kind': 'Kind',
  'duplicates.merged.col.into': 'Merged into',
  'duplicates.merged.col.on': 'Merged On',
  'duplicates.merged.col.by': 'Merged By',
  'duplicates.merged.col.until': 'Can Be Undone Until',
  'duplicates.merged.kind.company': 'Company',
  'duplicates.merged.kind.person': 'Person',
  'duplicates.merged.kind.item': 'Item',
  'duplicates.merged.kind.import': 'Zoho contact, by the import',
  'duplicates.merged.kind.importItem': 'Zoho item, by the import',
  'duplicates.merged.joinedIn': 'joined in import run',
  'duplicates.merged.joinedAs': 'as a second address',
  'duplicates.merged.ended': 'The 90 days ended',
  'duplicates.merged.count': 'merges can be undone',
  'duplicates.merged.empty': 'No merge has been made yet.',
  'duplicates.merged.undone': 'Merge undone. The record is back with its own fields.',
  'undoMerge.title': 'Undo Merge',
  'undoMerge.press': 'Undo Merge',
  'undoMerge.lead': 'returns with its own fields. What the search found tied to it goes back, what was made on the survivor since the merge stays, and what cannot be told is left for you.',
  'undoMerge.leadEmpty': 'This merge was made before merges kept a list of what moved, so the record returns empty, and nothing goes back unless you tick it.',
  'undoMerge.until': 'Can be undone until',
  'undoMerge.leadZoho': 'returns under its Zoho Books name. What its Zoho reference ties to it goes back, and Refresh From Zoho fills its own fields afterwards.',
  'undoMerge.zoho.title': 'Zoho Books References',
  'undoMerge.zoho.toldApart': 'This merge recorded nothing, so the company comes back by its Zoho reference. The one ticked is the only reference here whose Zoho name is not the survivor’s.',
  'undoMerge.zoho.pick': 'This merge recorded nothing, and the survivor holds several Zoho references with nothing saying which was the merged company’s. Tick the ones that were.',
  'undoMerge.zoho.refreshNeedsImport': 'Its own fields come back through Refresh From Zoho, which reads the contact through the importer. Without permission to run the importer, the company comes back with its Zoho name and links and none of its fields.',
  'undoMerge.refreshStopped': 'Refresh From Zoho stopped at the first refusal, after {done} of {total}. Press it again once the refusal is cleared.',
  'undoMerge.refresh': 'Refresh From Zoho',
  'undoMerge.openRecord': 'Open the Record',
  'undoMerge.done.lead': 'The merge is undone, and the record is back with',
  'undoMerge.done.rows': 'rows.',
  'undoMerge.done.refreshHint': 'Refresh From Zoho reads its Zoho Books contact again through the import and writes its fields onto it, as it stood before the merge.',
  'undoMerge.loading': 'Reading what moved…',
  'undoMerge.notRecorded': 'Not recorded',
  'undoMerge.group.belonged': 'Belonged to',
  'undoMerge.group.belongedHint': 'Found by the search, or by the merge’s own record of what it moved.',
  'undoMerge.reason.foldedJob': 'their job at {company}, folded into {into}’s at the merge',
  'undoMerge.reason.companyGone': 'the company it was at is gone since the merge',
  'undoMerge.reason.defaultSite': '{into} bills to this site by default, so it stays',
  'undoMerge.group.madeOn': 'Made on',
  'undoMerge.group.afterMerge': 'after the merge',
  'undoMerge.group.cantTell': 'Can’t Tell',
  'undoMerge.group.cantTellHint': 'Tick the ones that go back.',
  'undoMerge.group.none': 'None',
  'undoMerge.word.goesBack': 'goes back',
  'undoMerge.word.stays': 'stays',
  'undoMerge.word.cantTell': 'can’t tell',
  'undoMerge.kind.document': 'Document',
  'undoMerge.kind.deal': 'Deal',
  'undoMerge.kind.person': 'Person',
  'undoMerge.kind.job': 'Job',
  'undoMerge.kind.site': 'Site',
  'undoMerge.kind.file': 'File',
  'undoMerge.kind.note': 'Note',
  'undoMerge.kind.event': 'Event',
  'undoMerge.kind.line': 'Line',
  'undoMerge.kind.stock': 'Stock',
  'undoMerge.kind.supplier': 'Supplier',
  'undoMerge.kind.price': 'Price',
  'undoMerge.silent': 'of its own facts go back with it: tags, custom-field values, Zoho references, checks and the like.',
  'undoMerge.joined': 'rows joined the survivor’s own and stay with it.',
  'undoMerge.gone': 'rows are gone since the merge or name another record now, and stay where they are.',
  'undoMerge.summary.goBack': 'go back',
  'undoMerge.summary.stay': 'stay',
  'undoMerge.import.mergedInto': 'was merged into',
  'undoMerge.import.on': 'on',
  'undoMerge.import.earlierRun': 'in an earlier run.',
  'history.audit.mergeUndone': 'Merge undone',
  'history.audit.importMergeUndone': 'Import merge undone',
  'undoMerge.leadImport': 'is a Zoho Books contact the import merged into',
  'undoMerge.leadImportItem': 'is a Zoho item the import merged into',
  'undoMerge.leadImportItemTail': 'It comes back as its own item under its Zoho part number, with its Zoho reference. What that reference ties to it goes back, and Refresh From Zoho fills its fields afterwards.',
  'undoMerge.leadImportTail': 'It comes back as its own company under its Zoho Books name, with its Zoho reference. What that reference ties to it goes back, and Refresh From Zoho fills its fields afterwards.',
  'undoMerge.importWrote': 'The fields the Merge wrote stay on',
  'undoMerge.importWroteName': 'The Merge wrote the name too, so after the undo the survivor and the returned company read alike until one of them is renamed.',
  'undoMerge.nameThen': 'then',
  'undoMerge.importRenamedIs': 'is named',
  'undoMerge.importRenamedAgain': 'again.',
  'undoMerge.importNameUnknown': 'The name the survivor held before the Merge is not known, so after the undo it keeps the name it has now until a person renames it.',
  'undoMerge.importWroteNone': 'The Merge wrote no field into it.',
  'undoMerge.importWroteUnknown': 'This Merge was made before the import kept what it wrote, so any field it wrote stays as it is.',
  'undoMerge.importWas': 'was',
  'undoMerge.importEmpty': 'empty',
  'unit.row.one': 'row',
  'unit.row.other': 'rows',
} as const;
